/**
* 自定义报表
*/
const statement = {

  createUserDefinedStatement: "/api/createUserDefinedStatement",//创建报表
  modifyUserDefinedStatement: "/api/modifyUserDefinedStatement",//修改报表
  deleteUserDefinedStatement: "/api/deleteUserDefinedStatement",//删除报表
  getUserDefinedStatements: "/api/getUserDefinedStatements",//查询报表
  setUserDefinedStatements: "/api/setUserDefinedStatements",//设置报表格式
  getUserDefinedStatementConfig: "/api/getUserDefinedStatementConfig",//获取报表格式
  generateUserDefinedStatementDataDay: "/api/generateUserDefinedStatementDataDay",//生成表格数据
  generateUserDefinedStatementDataMonth: "/api/generateUserDefinedStatementDataMonth",//生成表格数据
  generateUserDefinedStatementDataYear: "/api/generateUserDefinedStatementDataYear",//生成表格数据
}

export default statement